// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border[data-v-de66d4e8]{border:1px dotted #00008b}.no-spin input[type=number][data-v-de66d4e8]{-moz-appearance:textfield}.not-text-transform[data-v-de66d4e8]{text-transform:none!important}", ""]);
// Exports
module.exports = exports;
